// extracted by mini-css-extract-plugin
module.exports = {"courseReqs":"styles_courseReqs__mUP3v","reqsList":"styles_reqsList__jbm77"};